import { render, staticRenderFns } from "./Result.Status.vue?vue&type=template&id=76d1cdac&"
import script from "./Result.Status.vue?vue&type=script&lang=js&"
export * from "./Result.Status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports